export default __webpack_public_path__ + "static/media/dental_health.32f017f4.png";